import React from "react";
import type { TranscriptItem } from "../hooks/useTranslator";

interface TranslationHistoryProps {
  meetingTranscript: TranscriptItem[];
  tgtLang: string;
  onSelectItem: (item: TranscriptItem) => void;
  onSpeak: (text: string, langCode: string, force: boolean) => void;
}

export const TranslationHistory: React.FC<TranslationHistoryProps> = ({
  meetingTranscript,
  tgtLang,
  onSelectItem,
  onSpeak,
}) => {
  return (
    <div className="w-full lg:w-[250px] flex-shrink-0 flex flex-col bg-[var(--sidebar-bg)] backdrop-blur-md border-b lg:border-b-0 lg:border-r border-[var(--border)] p-[16px] overflow-hidden max-h-[35vh] lg:max-h-none order-2 lg:order-1 transition-colors duration-300">
      <p className="text-[11px] font-semibold tracking-[0.05em] text-[var(--text-dim)] uppercase mb-[12px] pl-[4px]">
        Historial
      </p>

      <div className="flex-1 overflow-y-auto space-y-[8px] pr-1 scrollbar-thin scrollbar-thumb-white/10 scrollbar-track-transparent">
        {meetingTranscript.length === 0 ? (
          <p className="text-[13px] text-[var(--text-dim)] text-center mt-[40px]">
            El historial de la reunión aparecerá aquí...
          </p>
        ) : (
          [...meetingTranscript].reverse().map((item, index) => (
            <div
              key={index}
              onClick={() => onSelectItem(item)}
              className={`py-[10px] px-[12px] bg-[var(--surface)] hover:bg-white/[0.06] border border-[var(--border)] rounded-[8px] cursor-pointer transition-all duration-200 hover:border-[var(--accent)] hover:translate-x-1 active:translate-x-[2px] flex flex-col ${
                item.isMic ? "border-l-[3px] border-l-[var(--success)]" : ""
              }`}
              role="button"
              title="Haga clic para mostrar esta traducción en grande"
            >
              <div className="flex justify-between items-start gap-[8px]">
                <div className="flex-1 overflow-hidden">
                  <span className="text-[8px] font-mono text-[var(--text-dim)] mb-[4px] block">{item.timestamp}</span>
                  <p className="font-mono text-[10px] text-[var(--text-dim)] mb-[4px] truncate">{item.orig}</p>
                  <p className="text-[12px] font-medium text-[var(--text-muted)] leading-[1.4] line-clamp-2">{item.tran}</p>
                </div>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    onSpeak(item.tran, tgtLang, true);
                  }}
                  className="bg-transparent border-none cursor-pointer text-[16px] ml-[4px] opacity-60 hover:opacity-100 transition-opacity duration-200"
                  title="Escuchar traducción"
                >
                  🔊
                </button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};
